<template>
  <v-container fluid class="ma-0 pa-0" style="max-height: calc(100vh - 108px)">
    <!-- <HomeBar /> -->

    <div class="menuleft">
      <v-navigation-drawer permanent width="100%">
        <v-row class="mt-1">
          <v-col cols="12" style="background: #fafafa">
            <v-text-field
              v-model="input"
              rounded
              solo
              flat
              dense
              id="search"
              :label="t('pesquisarAtendimentos')"
              hide-details
            >
              <template v-slot:append>
                <v-icon>mdi-magnify</v-icon>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12">
            <v-btn text small color="#666" @click="devicesModal = true">
              <v-icon small>mdi-cog</v-icon>{{ t("ajusteDeAudio") }}
            </v-btn>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-list two-line subheader v-if="atendimentosCliente.length > 0">
          <v-subheader>
            {{ t("atendimentosDoCliente") }}
            <v-btn class="ml-5" icon @click="atendimentosCliente = []">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-subheader>
          <v-virtual-scroll
            :items="atendimentosCliente"
            :item-height="80"
            :height="300"
          >
            <template v-slot="{ item }">
              <v-list-item :key="item.id" @click="select(item)">
                <v-list-item-avatar>
                  <v-avatar
                    color="#0DC143"
                    v-if="
                      item.queueTypeID === 5 ||
                      item.queueTypeID === 3 ||
                      item.queueTypeID === 6 ||
                      item.queueTypeID === 7
                    "
                  >
                    <v-icon dark>mdi-whatsapp</v-icon>
                  </v-avatar>
                  <v-avatar color="indigo" v-if="item.queueTypeID === 1">
                    <v-icon dark>mdi-phone</v-icon>
                  </v-avatar>
                  <v-avatar color="deep-orange " v-if="item.queueTypeID === 4">
                    <v-icon dark>mdi-gmail</v-icon>
                  </v-avatar>
                  <v-avatar color="primary" v-if="item.queueTypeID === 2">
                    <v-icon dark>mdi-forum</v-icon>
                  </v-avatar>
                  <!-- <v-icon :class="[item.iconClass]" v-text="item.icon"></v-icon> -->
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title
                    v-if="item.idCliente !== 9999999 || !item.fromName"
                    v-text="item.fromName"
                  ></v-list-item-title>
                  <v-list-item-title
                    v-else
                    v-text="item.fromID"
                  ></v-list-item-title>
                  <v-list-item-subtitle
                    v-text="'#' + item.id"
                  ></v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <v-list-item-action-text>{{
                    formataHora(item.dataIni)
                  }}</v-list-item-action-text>
                  <v-row no-gutters>
                    <v-col>
                      <v-badge
                        v-show="item.count > 0"
                        color="#09d261"
                        :content="item.count"
                        :inline="true"
                      ></v-badge>
                    </v-col>
                  </v-row>
                </v-list-item-action>
              </v-list-item>
              <v-divider :key="item.id" inset></v-divider>
            </template>
          </v-virtual-scroll>
        </v-list>
        <v-list two-line subheader>
          <v-subheader>{{ t("FilaDeEspera") }}</v-subheader>
          <v-list-item class="mt-1" style="justify-content: center">
            <v-badge
              color="blue"
              :content="totalAguardandoChat ? totalAguardandoChat : '0'"
              class="ml-3 mr-3"
            >
              <v-icon color="blue" size="28px">mdi-forum</v-icon>
            </v-badge>
            <v-badge
              color="green"
              :content="totalAguardandoWhats ? totalAguardandoWhats : '0'"
              class="ml-3 mr-3"
            >
              <v-icon color="green" size="28px">mdi-whatsapp</v-icon>
            </v-badge>
            <v-badge
              color="red"
              :content="totalAguardandoEmail ? totalAguardandoEmail : '0'"
              class="ml-3 mr-3"
            >
              <v-icon color="red" size="28px">mdi-email</v-icon>
            </v-badge>
            <v-badge
              color="primary"
              :content="totalAguardandoVoz ? totalAguardandoVoz : '0'"
              class="ml-3 mr-3"
            >
              <v-icon color="primary" size="28px">mdi-phone</v-icon>
            </v-badge>
          </v-list-item>
          <v-divider></v-divider>
        </v-list>

        <div style="max-height: 50vh; overflow-y: scroll; overflow-x: hidden">
          <v-list two-line subheader v-if="calls && calls.length > 0">
            <v-subheader>{{ t("ligacoesAtivas") }}</v-subheader>
            <template v-for="(item, index) in calls">
              <v-hover v-slot:default="{ hover }" :key="index">
                <v-list-item
                  :key="item.callid"
                  @click="
                    selectCall(item);
                    select(null);
                  "
                  @mouseover="
                    call = item;
                    atendimento = item.atendimento;
                  "
                >
                  <v-list-item-avatar>
                    <v-avatar color="indigo">
                      <v-icon dark>mdi-phone</v-icon>
                    </v-avatar>
                    <!-- <v-icon :class="[item.iconClass]" v-text="item.icon"></v-icon> -->
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title
                      v-if="item.atendimento"
                      v-text="
                        item.atendimento.fromName
                          ? item.atendimento.fromName
                          : item.atendimento.fromID
                      "
                    ></v-list-item-title>
                    <v-list-item-title
                      v-else
                      v-text="item.nome ? item.nome : item.numero"
                    ></v-list-item-title>
                    <v-list-item-subtitle
                      v-text="item.fila"
                    ></v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-row no-gutters>
                      <v-col v-show="hover">
                        <v-menu
                          :key="item.title"
                          transition="slide-y-transition"
                          bottom
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" icon small>
                              <v-icon>mdi-menu-down</v-icon>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item-group>
                              <v-list-item @click="getAtendimentosCliente()">
                                <v-list-item-title>{{
                                  t("ultimosAtendimentos")
                                }}</v-list-item-title>
                              </v-list-item>
                            </v-list-item-group>
                          </v-list>
                        </v-menu>
                      </v-col>
                    </v-row>

                    <v-list-item-action-text>{{
                      formataHora(item.dataini)
                    }}</v-list-item-action-text>
                  </v-list-item-action>
                </v-list-item>
              </v-hover>
              <v-divider :key="item.callid" inset></v-divider>
            </template>
            <v-row>
              <v-col cols="6">
                <div class="d-flex flex-row">
                  <v-slider
                    v-model="volume"
                    min="0"
                    max="100"
                    thumb-label
                  ></v-slider>
                  <v-btn icon @click="toggleMute">
                    <v-icon v-if="!isMuted">mdi-headset</v-icon>
                    <v-icon v-else>mdi-headset-off</v-icon>
                  </v-btn>
                </div>
              </v-col>
              <v-col cols="6">
                <div class="d-flex flex-row">
                  <v-slider
                    id="mic"
                    v-model="mic"
                    min="0"
                    max="100"
                    thumb-label
                  ></v-slider>
                  <v-btn icon @click="toggleMicAll">
                    <v-icon v-if="!isMicMute">mdi-microphone</v-icon>
                    <v-icon v-else>mdi-microphone-off</v-icon>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-list>
          <v-list two-line subheader v-if="atendimentosCliente.length == 0">
            <v-subheader
              >{{ t("atendimentosAtivos")
              }}{{
                ` (${
                  uniqAtendimentos.filter((a) => a.queueTypeID !== 1).length
                })`
              }}</v-subheader
            >
            <v-virtual-scroll
              :items="filtroAtendimentos"
              :item-height="80"
              :height="300"
            >
              <template v-slot="{ index, item }">
                <v-hover v-slot:default="{ hover }" :key="index">
                  <v-list-item
                    :key="item.id"
                    @click="
                      select(item);
                      selectCall(null);
                    "
                    @mouseover="
                      atendimento = item;
                      fila = filas.find((f) => f.name == item.queue);
                    "
                  >
                    <v-list-item-avatar>
                      <v-avatar
                        color="#0DC143"
                        v-if="
                          item.queueTypeID === 5 ||
                          item.queueTypeID === 3 ||
                          item.queueTypeID === 6 ||
                          item.queueTypeID === 7
                        "
                      >
                        <v-icon dark>mdi-whatsapp</v-icon>
                      </v-avatar>
                      <v-avatar color="indigo" v-if="item.queueTypeID === 1">
                        <v-icon dark>mdi-phone</v-icon>
                      </v-avatar>
                      <v-avatar
                        color="deep-orange "
                        v-if="item.queueTypeID === 4"
                      >
                        <v-icon dark>mdi-gmail</v-icon>
                      </v-avatar>
                      <v-avatar color="primary" v-if="item.queueTypeID === 2">
                        <v-icon dark>mdi-forum</v-icon>
                      </v-avatar>
                      <!-- <v-icon :class="[item.iconClass]" v-text="item.icon"></v-icon> -->
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title
                        v-if="item.idCliente !== 9999999 || !item.fromName"
                        v-text="item.fromName"
                      ></v-list-item-title>
                      <v-list-item-title
                        v-else
                        v-text="item.fromID"
                      ></v-list-item-title>
                      <v-list-item-subtitle
                        v-text="'#' + item.id"
                      ></v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-action>
                      <v-list-item-action-text>{{
                        formataHora(item.dataIni)
                      }}</v-list-item-action-text>
                      <v-row no-gutters>
                        <v-col>
                          <v-badge
                            v-show="item.count > 0"
                            color="#09d261"
                            :content="item.count"
                            :inline="true"
                          ></v-badge>
                        </v-col>
                        <v-col v-show="hover">
                          <v-menu
                            :key="item.title"
                            transition="slide-y-transition"
                            bottom
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-bind="attrs" v-on="on" icon small>
                                <v-icon>mdi-menu-down</v-icon>
                              </v-btn>
                            </template>
                            <v-list>
                              <v-list-item-group>
                                <v-list-item @click="getAtendimentosCliente()">
                                  <v-list-item-title>{{
                                    t("ultimosAtendimentos")
                                  }}</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="modalEncerra = true">
                                  <v-list-item-title>{{
                                    t(`encerrarAtendimento`)
                                  }}</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="modalClassificacao = true">
                                  <v-list-item-title>{{
                                    t(`classificar`)
                                  }}</v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                  v-if="item.queueTypeID !== 1"
                                  @click="modalTransfere = true"
                                >
                                  <v-list-item-title>{{
                                    t(`transferirAtendimento`)
                                  }}</v-list-item-title>
                                </v-list-item>
                              </v-list-item-group>
                            </v-list>
                          </v-menu>
                        </v-col>
                      </v-row>
                    </v-list-item-action>
                  </v-list-item>
                </v-hover>

                <!-- <v-divider :key="item.id" inset></v-divider> -->
              </template>
            </v-virtual-scroll>
          </v-list>
        </div>

        <!-- <template v-slot:append>
          <div class="pa-0">
            <AgenteBar />
          </div>
        </template>-->
      </v-navigation-drawer>
    </div>

    <!-- MODAL CLASSIFICACAO -->
    <Classificar
      v-if="atendimento"
      :open="modalClassificacao"
      :queueTypeID="atendimento.queueTypeID"
      :atendimento="atendimento"
      v-on:updateClassificar:open="modalClassificacao = $event"
      :cancelar="true"
    />
    <!-- MODAL CLASSIFICACAO -->
    <Encerrar
      v-if="atendimento && fila"
      :open="modalEncerra"
      :queueTypeID="atendimento.queueTypeID"
      :atendimento="atendimento"
      :fila="fila"
      v-on:updateEncerrar:open="modalEncerra = $event"
    />

    <!-- MODAL encerramento -->

    <b-modal id="encerra-modal1" centered header-bg-variant="danger">
      <template v-slot:modal-header variant="light">
        <span style="color: #fff">{{ t("Alerta") }}</span>
      </template>
      <span>{{ t("fraseEncerramento") }}</span>
      <template v-slot:modal-footer="{ ok }">
        <b-button
          variant="light"
          @click="
            ok();
            encerraAtendimento(atendimento);
          "
          >{{ t("sim") }}</b-button
        >
        <b-button variant="light" @click="ok()">{{ t("nao") }}</b-button>
      </template>
    </b-modal>
    <!-- MODAL encerramento -->

    <!-- MODAL transferencia -->
    <Transferencia
      v-if="atendimento !== null"
      :open="modalTransfere"
      :atendimento="atendimento"
      v-on:update:open="modalTransfere = $event"
    ></Transferencia>
    <!-- MODAL transferencia -->
    <AjusteAudio
      :open="devicesModal"
      :inputDevices="inputDevices"
      :outputDevices="outputDevices"
      v-on:update="devicesModal = $event"
    ></AjusteAudio>
  </v-container>
</template>
   
<script>
import HomeBar from "../bars/Home";
import { mapActions } from "vuex";
import { mapState } from "vuex";
import moment from "moment";
import filter from "../../plugins/Filter";
import { debounce } from "../../plugins/Debounce";
import Transferencia from "../dialogs/Transferencia";
import Classificar from "../dialogs/Classificar";
import AjusteAudio from "../dialogs/AjusteAudio";
import Encerrar from "../dialogs/Encerrar";

import uniq from "lodash/uniq";

export default {
  name: "Left-Menu",
  components: {
    HomeBar,
    Transferencia,
    Classificar,
    AjusteAudio,
    Encerrar,
  },
  props: {
    title: { type: String, default: "Title" },
  },
  data() {
    return {
      search: null,
      input: "",
      volume: 100,
      mic: 100,
      isMicMute: false,
      isMuted: false,
      menu: false,
      devicesModal: false,
      modalEncerra: false,
      modalClassificacao: false,
      modalTransfere: false,
      atendimentosCliente: [],
      atendimento: null,
      fila: null,
      inputDevices: [],
      outputDevices: [],
      totalHeight: 0,
      windowHeight: 0,
      config: JSON.parse(localStorage.getItem("config")),
    };
  },
  created() {
    this.calcHeight();
    window.addEventListener("resize", () => {
      this.calcHeight();
    });
    navigator.mediaDevices
      .enumerateDevices()
      .then(this.gotDevices)
      .catch((err) => console.log(err));
    setInterval(() => {
      navigator.mediaDevices
        .enumerateDevices()
        .then(this.gotDevices)
        .catch((err) => console.log(err));
    }, 5000);
  },
  watch: {
    nome(nw) {
      if (nw) {
        this.getAtendimentos(this.user);

        let dataIni = new Date();
        dataIni = moment(dataIni).subtract(1, "months");
        dataIni = moment(dataIni).format();
        let dataFim = new Date();
        dataFim = moment(dataFim).format();

        this.getAllAtendimentos({
          dataIni: dataIni,
          dataFim: dataFim,
        });
      }
    },
    volume(newValue) {
      this.setVolumePhone(newValue / 100);
    },
    mic(newValue) {
      this.setVolumeMic(newValue / 100);
      //win.mic.set(newValue);
    },
    input: debounce(function (newVal) {
      this.search = newVal;
    }, 500),
  },
  methods: {
    ...mapActions("xc", [
      "addAtendimento",
      "selectAtendimento",
      "getDefault",
      "newWhatsApp",
      "getAllAtendimentos",
      "getAtendimentos",
      "encerrarAtendimento",
      "setModalConfig",
      "addMessages",
    ]),
    ...mapActions("sip", [
      "selectNewCall",
      "setMuteMicAll",
      "setMutePhoneAll",
      "setVolumeMic",
      "setVolumePhone",
    ]),
    gotDevices(deviceInfos) {
      try {
        for (let i = 0; i !== deviceInfos.length; ++i) {
          const deviceInfo = deviceInfos[i];
          let value = deviceInfo.deviceId;
          if (deviceInfo.kind === "audioinput") {
            let text =
              deviceInfo.label || `microphone ${this.inputDevices.length + 1}`;
            this.inputDevices.push({ text: text, value: value });
          } else if (deviceInfo.kind === "audiooutput") {
            let text =
              deviceInfo.label || `speaker ${this.outputDevices.length + 1}`;
            this.outputDevices.push({ text: text, value: value });
          } else {
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    toggleMute() {
      //this.audio.volume = this.isMuted ? this.volume / 100 : 0;
      this.isMuted = !this.isMuted;
      this.setMutePhoneAll(this.isMuted);
    },
    getCliente() {
      if (this.clientes && this.clientes !== null && this.clientes.length > 0) {
        let cliente = this.clientes.find(
          (c) => c.id === this.atendimento.idCliente
        );

        return cliente;
      }
    },
    async encerraAtendimento(atendimento) {
      try {
        console.log(atendimento);
        console.log(this.filas);
        let fila = this.filas.find((f) => f.name === atendimento.queue);
        if (fila.obrigaClassificar) {
          // return this.httpClient.get<any[]>(`${this.url}/api/v2/chat/${protocolo}/classificacoes?max=-1&page=1`);
          // this.modalClassificacao = true;
          let retorno = await this.getDefault(
            `/api/v2/chat/${atendimento.id}/classificacoes?max=-1&page=1`
          );

          if (retorno && retorno.dados && retorno.dados.length > 0) {
            this.encerrarAtendimento(atendimento);
          } else {
            this.modalClassificacao = true;
          }
        } else {
          this.encerrarAtendimento(atendimento);
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getClienteByID() {
      try {
        console.log(this.atendimento);
        let retorno = await this.getDefault(
          `/api/v2/clientes/${this.atendimento.idCliente}`
        );
        //eslint-disable-next-line no-unused-vars
        /* eslint-disable  */
        return retorno;
      } catch (error) {
        console.error(error);
      }
    },
    async getAtendimentosCliente() {
      let cliente = await this.getClienteByID();
      if (cliente !== null) {
        let protocolos = await this.getDefault(
          `/api/v2/atendimentos/${cliente.id}`
        );
        let filas = this.user.filas.map((f) => f.fila);
        let atendimentos = protocolos.filter((a) => {
          if (filas.indexOf(a.queue) !== -1) {
            return true;
          }
        });
        atendimentos = atendimentos.map((a) => {
          let obj = a;
          obj.pesquisa = true;
          return obj;
        });
        atendimentos = atendimentos.filter((a) => a.id !== this.atendimento.id);
        atendimentos.sort(function (a, b) {
          return b.id - a.id;
        });
        this.atendimentosCliente = atendimentos;
      }
    },
    async getMessages(item) {
      try {
        let retorno = await this.getDefault(
          `/api/v2/chat/${item.id}/mensagens?max=-1&page=1`
        );
        //this.messages = retorno.dados;
        if (!retorno.dados) {
          retorno.dados = [];
        }

        await this.addMessages(retorno.dados);
      } catch (error) {
        console.error(error);
      }
    },
    async select(item) {
      try {
        // await this.getMessages(this.atendimento);
        let atendimentos = localStorage.getItem(`atendimentos`);
        if (atendimentos && item) {
          atendimentos = JSON.parse(atendimentos);
          let atendimento = atendimentos.find((a) => a.id === item.id);
          if (atendimento) atendimento.count = 0;
          localStorage.setItem(`atendimentos`, JSON.stringify(atendimentos));
        }
        if (this.$route.name !== `home`) {
          this.selectAtendimento(item);
          this.$router.push(`./home`);
        }
        if (!item) this.selectAtendimento(item);

        if (item.queueTypeID === 1) {
          let call = {};
          call.dataini = item.dataIni;
          call.numero = item.fromID;
          call.datafim = item.dataFim;
          call.atendimento = item;
          call.fila = item.queue;
          call.idCliente = item.idCliente;
          call.dados = {};
          console.log(item);
          this.selectNewCall(call);
          //this.selectAtendimento(item);
        } else {
          this.selectAtendimento(item);
          this.selectNewCall(null);
        }
      } catch (error) {
        console.error(error);
      }
    },
    selectCall(call) {
      if (this.$route.name !== `home`) {
        this.selectNewCall(call);
        this.$router.push(`./home`);
      }
      this.selectNewCall(call);
    },
    filterByQueue() {
      let filas = this.user.filas.map((f) => f.fila);
      let atendimentos = this.atendimentosSearch.filter((a) => {
        if (filas.indexOf(a.queue) !== -1) {
          return true;
        }
      });
      return atendimentos;
    },
    toggleMicAll() {
      this.isMicMute = !this.isMicMute;
      this.setMuteMicAll(this.isMicMute);
      // win.mic.isMuted() ? win.mic.unmute() : win.mic.mute();
      // this.isMicMute = win.mic.isMuted();
    },
    formataHora(dataHora) {
      let isToday = moment(0, "HH").diff(dataHora, "days") == 0;
      console.log(dataHora, moment(0, "HH").diff(dataHora, "days"));
      if (isToday) {
        moment.locale("pt-br");
        return moment(dataHora).format("LT");
      } else {
        moment.locale();
        return moment(dataHora).format("L");
      }
    },
    sumlength(items, prop) {
      return items.reduce(function (a, b) {
        return a + b[prop].length;
      }, 0);
    },
    calcHeight() {
      this.totalHeight = window.innerHeight;
      if (this.totalHeight > 1000) {
        this.windowHeight = 600;
      } else if (this.totalHeight > 800) {
        this.windowHeight = 300;
      } else {
        this.windowHeight = 300;
      }
      //this.windowHeight = window.innerHeight * (70 / 100);
    },
  },
  computed: {
    ...mapState("xc", {
      atendimentos: (state) => state.atendimentos,
      atendimentosSearch: (state) => state.atendimentosSearch,
      cliente: (state) => state.cliente,
      pausas: (state) => state.pausas,
      clientes: (state) => state.clientes,
      filas: (state) => state.filas,
      filaStatus: (state) => state.filaStatus,
    }),
    ...mapState("auth", {
      user: (state) => state.user,
      nome: (state) => state.user.fullname,
    }),
    ...mapState("sip", {
      calls: (state) => state.calls,
    }),
    filasFiltradas() {
      let filas = this.user.filas.map((f) => f.fila);

      let retorno = this.filaStatus.filter(
        (f) => filas.findIndex((fila) => fila === f.nome) !== -1
      );
      return retorno;
    },
    filasWhats() {
      return this.filasFiltradas.filter(
        (f) =>
          f.queue_type === 3 ||
          f.queue_type === 5 ||
          f.queue_type === 6 ||
          f.queue_type === 7
      );
    },
    totalAguardandoWhats: function () {
      return this.sumlength(this.filasWhats, "ligacoes");
    },
    filasChat() {
      return this.filasFiltradas.filter((f) => f.queue_type === 2);
    },
    totalAguardandoChat: function () {
      return this.sumlength(this.filasChat, "ligacoes");
    },
    filasEmail() {
      return this.filasFiltradas.filter((f) => f.queue_type === 4);
    },
    totalAguardandoEmail: function () {
      return this.sumlength(this.filasEmail, "ligacoes");
    },
    filasVoz() {
      return this.filasFiltradas.filter((f) => f.queue_type === 1);
    },
    totalAguardandoVoz: function () {
      return this.sumlength(this.filasVoz, "ligacoes");
    },
    totalAguardando: function () {
      return this.sumlength(this.filasFiltradas, "ligacoes");
    },
    filtroAtendimentos: function () {
      if (!this.atendimentos || this.atendimentos === null) return;
      if (this.search && this.search.length > 0) {
        return filter.transform(
          this.atendimentos.filter((a) => a.queueTypeID !== 1),
          this.search,
          [`id`, `fromName`, `fromID`]
        );
      } else {
        return this.atendimentos.filter((a) => a.queueTypeID !== 1);
      }
    },
    uniqAtendimentos() {
      // return this.atendimentos;
      let atendimentos = uniq(this.atendimentos);

      return atendimentos;
    },
  },
};
</script>

<style scoped>
.menuleft {
  margin-top: 2px;
  height: calc(100vh - 110px);
  overflow-y: auto;
}
</style>